










import {Component, Prop, Vue} from 'vue-property-decorator';
import CFlexGrid from '@/components/base/flex-grid/CFlexGrid.vue';
@Component({
    components: {CFlexGrid},
    inheritAttrs: false,
})
export default class EquipmentTypeVeneerProcessGroup extends Vue {
    @Prop() parent!: any;
}
